<template>
  <!--REPLY CARD-->
  <div id="replyEm">
    <LoadingSpinner v-if="startLoadingSendEmail" />
    <h6 v-if="emailSent" class="text-success align-center py-3">
      <i class="icon-checkmark"></i>
      {{ this.$t("lang.label.emailwassentsuccessfully") }}
    </h6>
    <div
      class="card notEffect replyEmail mt-3 p-3"
      v-if="!startLoadingSendEmail && !emailSent"
    >
      <div class="row rowborder not-Margin">
        <div class="col-12">
          <div class="d-flex justify-content-end">
            <div class="mr-auto align-self-center" v-if="showBtn === true">
              <button class="btn btn-secondary" @click="close()">
                <i class="icon-close"></i>
                Close
              </button>
            </div>
            <div
              class="btn-group my-2"
              role="group"
              aria-label="Button group with nested dropdown"
            >
              <div class="btn-group" role="group">

                <button
                  v-if="true"
                  @click="generate_answer()"
                  id="btnGroupDrop1"
                  type="button"
                  class="btn btn-secondary themed-button buttonSeparator"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ $t("lang.opportunities.generateanswer") }}
                </button>

                <button
                  @click="show_prompts()"
                  id="btnGroupDrop1"
                  type="button"
                  class="btn btn-secondary themed-button buttonSeparator"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="showPrompts === false"
                >
                  {{ $t("lang.opportunities.viewprompts") }}
                </button>

                <button
                  @click="hide_prompts()"
                  id="btnGroupDrop1"
                  type="button"
                  class="btn btn-secondary themed-button buttonSeparator"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="showPrompts === true"
                >
                  {{ $t("lang.opportunities.hideprompts") }}
                </button>

                <button
                  @click="response_email()"
                  id="btnGroupDrop1"
                  type="button"
                  class="btn btn-secondary themed-button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="icon-reply-all mr-2"></i>
                  {{ $t("lang.button.replythisemail") }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row rowborder col-12" v-if="showPrompts === true">
        <br>
        <span>
          <b>System prompt:</b>
          <br>
          {{ this.systemPrompt }}
          <br>
          <br>
          <b>User prompt:</b>
          <br>
          {{ this.userPrompt }}
        </span>
        <br>
      </div>

      <div class="row rowborder not-Margin mt-2 mb-1">
        <div class="col-12">
          <div class="">
            <vue-form-generator
              ref="emailForm"
              :schema="schemaEmail"
              :model="reply_email"
              :options="formOptions"
            ></vue-form-generator>
          </div>
        </div>
      </div>


      <div class="row not-Margin">
        <div class="col-12">

          <!-- Show the calendar availability -->
          <div class="row">
            <template v-if="!showAvailableCalendar">
              <div class="col-12 mb-2 text-primary" @click="showAvailableCalendar = !showAvailableCalendar" >
                Show the calendar availability
                <i class="icon-caret-down1 ml-2 mt-2"></i>
              </div>
            </template>

            <template v-else>
              <div class="col-12 mb-2 text-primary" @click="showAvailableCalendar = !showAvailableCalendar">
                Show the calendar availability
                <i class="icon-caret-up1 ml-2 mt-2"></i>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-6">
                    <small>Timezone</small>
                    <select
                      v-model="timezone"
                      @change="selectTimeZone($event)"
                      class="form-control w-100"
                    >
                      <option value="false" v-if="!timezone" selected>
                        {{ $t("lang.label.choose") }}
                      </option>
                      <option
                        v-for="(lang, i) in timezones"
                        :key="`Lang${i}`"
                        :value="lang.id"
                      >
                        {{ lang.label }}
                      </option>
                    </select>
                  </div>
                </div>
                
              </div>
              <div class="col-12 mb-1" v-if="timezoneSource">
                <small class="text-muted">
                  {{ $t("lang.calendar.slotsTimezone." + timezoneSource) }}: <b>{{ selectedZoneName }}</b>
                </small>
              </div>
              <div class="col-3">
                <small>Month</small>
                <select
                  class="form-control form-control-sm"
                  v-model="currentmonth"
                  @change="changeMonthSelected"
                  :disabled="loading"
                >
                  <option v-for="month of months" :key="month.id" :value="month.id">
                    {{  month.name }}
                  </option>                              
                </select>
              </div>

              <div class="col-3">
                <small>Day</small>
                <select
                  class="form-control form-control-sm"
                  v-model="dateAvailableSelected"
                  :key="keyDateAvailable"
                  :disabled="datesAvailableToMonthSelected.length == 0 || loading"
                  @change="changeDatesAvailableToMonthSelected"                  
                >
                  <option v-for="(item, i) of datesAvailableToMonthSelected" :key="i" :value="item.day">
                    {{ item.day }} - {{ item.dayName }}
                  </option>                              
                </select>
              </div>

              <div class="col-3">
                <small>Hour</small>
                <select
                  class="form-control form-control-sm"
                  v-model="hoursAvailableSelected"
                  :key="keyHoursAvailable"
                  :disabled="hoursAvailable.length == 0 || loading"  
                >
                  <option v-for="(item, i) of hoursAvailable" :key="i">
                      {{ item }}
                   </option> 
                </select>
              </div>

              <div class="col-3 pt-4" @click="copyToClipboard(dateAvailableSelected + ' - ' + hoursAvailableSelected + copiedZoneSuffix)">
                <button  
                  class="btn btn-secondary btn-sm"
                  :disabled="datesAvailableToMonthSelected.length == 0 || hoursAvailable.length == 0 || !hoursAvailableSelected || !dateAvailableSelected"
                  >Copy to clipboard <i class="icon-copy ml-2"></i>
                  
                </button>
              </div>
            </template>
        </div>
        <!-- END Show the calendar availability -->


          <div class="">
            <div class="mt-4 mb-4">
              <div class="field-ckeditor-wrappar">
                <ValidationProvider
                  ref="editorMessageV"
                  :rules="{ required: true }"
                >
                  <div slot-scope="{ errors }">
                    <div
                      class="
                        form-group
                        valid
                        featured
                        required
                        field-input field-ckeditor
                      "
                      :class="errors.length > 0 ? 'error' : ''"
                    >
                      <label> {{ $t("lang.label.message") }}</label>

                      <ckeditor
                        :editor="editorInitial"
                        v-model="editorData"
                        :config="editorConfig"
                      ></ckeditor>

                      <div class="errors help-block">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row not-Margin row-btn-footer">
        <div class="col-12">
          <div class="alert alert-danger w-100 mt-2" v-if="errors.length">
            <ul>
              <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
          </div>
          <div class="d-flex justify-content-between">
            <div class="content-btn-left btn-group" role="group">
              <button @click="cleanFields()" class="btn border-success rounded">
                <i class="icon-eraser mr-2"></i>
                <span class="font-weight-bold">{{
                  $t("lang.label.clean")
                }}</span>
              </button>
              <button 
                class="
                  btn btn-primary
                  themed-button
                  btn-sm
                  dropdown-toggle
                  ml-2
                  rounded
                "
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-if="templateList.length > 0"
              >
                <i class="icon-write mr-2"></i>
                {{ $t("lang.emailsettings.templates") }}
              </button>
              <div class="dropdown-menu overflow-auto" style="max-height: 350px;">
                <a
                  v-for="(template, key) in this.templateList"
                  :key="key"
                  v-on:click="addTemplete(template.id)"
                  class="dropdown-item c-pointer hover-bg token"
                >
                  {{ template.title }}
                </a>
              </div>
            </div>
            <div class="content-btn-right btn-group" role="group">
              <button
                @click="sendEmail()"
                class="btn btn btn-sm btn-success rounded"
              >
                <i class="icon-paper-plane mr-2"></i>
                <span class="font-weight-bold">{{
                  $t("lang.label.send")
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--//REPLY CARD-->
</template>
<script>
import { mapActions, mapState } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { emailsService } from "@/_services";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import { openaiService, myCalendarService, opportunitiesService } from "@/_services";
import moment from "moment";

export default {
  data() {
    return {
      keyHoursAvailable: 1,
      showAvailableCalendar: false,
      hoursAvailableSelected: null,
      hoursAvailable: [],
      myhs: false,
      myhsdefault: false,
      keyDateAvailable: 1,
      datesAvailableToMonthSelected: [],
      dateAvailableSelected: null,
      months: [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" }
      ],
      loadingfirst: true,
      loading: false,
      theyear: 2025,
      monthlabel: "",
      currentmonth: 1,
      timezone: 160,
      timezoneSource: null,
      countryOffParis: false,
      timezones: [],
      calendar: {
        title: "30 Minute Meeting",
        duration: "30 min",
        currentmonth: "",
        labelmonth: "",
        labeldays: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
        days: [],
        hours: [],
        name: "",
        accountId: false,
        currentmonth: false,
        currentyear: false,
        defaultTimezone: false,
        timezonelabel: "Europe/Paris",
      },
      errors: [],
      emailSent: false,
      reply_email: {
        response_id: "",
        to: "",
        cc: "",
        subject: "",
        message: "",
        email_selected: {},
      },
      startLoadingSendEmail: false,
      showPrompts: false,
      showBtn: Boolean,
      editorInitial: ClassicEditor,
      editorData: "",
      systemPrompt: "",
      userPrompt: "",
      editorConfig: {
        /*plugins: [ Essentials, Heading, Bold, Italic, Link, AutoPlaceholder ],*/
        toolbar: ["heading", "|", "bold", "italic", "|", "link"],
      },
      loadingTemplates: false,
      schemaEmail: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: "To",
            model: "to",
            required: true,
            min: 5,
            max: 255,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "field-inline",
          },
          {
            type: "input",
            inputType: "text",
            label: "CC",
            model: "cc",
            required: false,
            min: 5,
            max: 255,
            validator: ["emailListValidator"],
            styleClasses: "field-inline",
          },
          {
            type: "input",
            inputType: "text",
            label: "Subject",
            model: "subject",
            required: true,
            min: 5,
            max: 1000,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
            ],
            styleClasses: "field-inline",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  props: {
    selected: {},
    closebtn: Boolean,
    user_id: null,
  },

  components: {
    LoadingSpinner,
    ckeditor: CKEditor.component,
  },

  watch: {
    // "reply_email.subject"() {
    //   this.reply_email.subject = this.$sanitize(this.reply_email.subject);
    // },
    // "reply_email.message"() {
    //   this.reply_email.message = this.$sanitize(this.reply_email.message);
    // },
    editorData: function () {
      this.reply_email.message = this.$sanitize(this.editorData);
    },
  },

  created() {
    this.reply_email.email_selected = this.selected;
    this.showBtn = this.closebtn;
    this.response_email();
    this.getTemplateList();
    this.getCalendarDatesAvailable();
  },

  computed: {
		...mapState({		
      currentUser: (state) => state.authentication.user,
      TimeZone: (state) => state.optionsList.all["timezones"].data,
		}),
    selectedZoneName() {
      const zone = (this.timezones || []).find((item) => item.id == this.timezone);
      return zone ? zone.label.split(" ")[0] : "";
    },
    // El huso va en el texto copiado si no es Paris, o si el pais del prospecto se
    // conoce, no esta a la hora de Paris y no se le encontro huso (aunque sea Paris).
    copiedZoneSuffix() {
      if (!this.selectedZoneName) {
        return "";
      }
      return this.selectedZoneName !== "Europe/Paris" || this.countryOffParis
        ? " (" + this.selectedZoneName + ")"
        : "";
    },
    templateList() {
      const linkId = this.selected && this.selected.link_id;
      if (!linkId) {
        return [];
      }
      const list = this.$store.getters["emails/templatesForLink"](linkId);
      return list !== undefined ? list : [];
    },
	},

  mounted() {
    this.isValidEmailForm();
  },

  methods: {
    getCalendarDatesAvailable(){

      // const textToHash = "oliverlististhebest"+ Math.floor(Math.random() * 100) + 1;
      // this.myhsdefault = textToHash;
      // // Convertir la cadena a bytes
      // const bytes = new TextEncoder().encode(textToHash);
      // // Aplicar SHA-256
      // window.crypto.subtle.digest('SHA-1', bytes).then(hashBuffer => {
      //   const hashArray = Array.from(new Uint8Array(hashBuffer));
      //   const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
        
      //   // Mostrar el hash en hexadecimal
      //   this.myhs = hashHex;
      //  }).catch(error => {
      //  });



      
      let d = new Date();
      this.currentmonth = d.getMonth() + 1;
      this.account_id = btoa(this.user_id);
      this.calendar.accountId = this.account_id;

      this.$store.dispatch("optionsList/getTimezones").then(() => {
        this.timezones = this.TimeZone; // viene del mapState
        // Las horas copiadas las lee el prospecto: huso de su empresa, si no el del calendario del comercial, si no Paris
        opportunitiesService
          .getProspectTimezone(this.selected && this.selected.id, this.user_id)
          .then((res) => {
            this.timezoneSource = res.source;
            this.countryOffParis = !!res.country_off_paris;
            this.selectTimeZone(res.timezone_id);
          })
          .catch(() => {
            this.timezoneSource = "default";
            this.countryOffParis = false;
            this.selectTimeZone(160);
          });
      });
    },
    isUserBdr() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2)
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        //const copyDateSelected = `${dateAvailableSelected}`
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    changeMonthSelected(){
      this.datesAvailableToMonthSelected = []
      this.hoursAvailable = []
      this.hoursAvailableSelected = null

      const currentMonth = moment().month() + 1;

      if(this.currentmonth >= currentMonth){
        this.nextMonth(this.currentmonth, false);
      }

      
    },
    changeDatesAvailableToMonthSelected(){
      this.hoursAvailable = []
      this.hoursAvailableSelected = null
      
      const day = Number(moment(this.dateAvailableSelected, 'YYYY-MM-D').format('DD'))
      const month = Number(moment(this.dateAvailableSelected, 'YYYY-MM-D').format('MM'))
      const year= Number(moment(this.dateAvailableSelected, 'YYYY-MM-D').format('YYYY'))

      myCalendarService
        .getAvailabilityByDay(
          day,
          month,
          year,
          this.account_id,
          this.timezone,
          this.myhs
        )
        .then((res) => {
          this.hoursAvailable = res
        });
    },
    nextMonth(currentmonth, saveactivity) {
      if (currentmonth == 13) {
        currentmonth = 1;
        this.theyear++;
      }
      if (currentmonth == 0) {
        currentmonth = 12;
        this.theyear--;
      }
      this.currentmonth = currentmonth;
      let month = [
        "january",
        "frebruary",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];
      this.monthlabel = month[currentmonth - 1];
      this.getAvailabilityByMonth(currentmonth, this.theyear, this.account_id);

      // if (
      //   saveactivity &&
      //   typeof this.business_contact_hash !== "undefined" &&
      //   typeof this.campaign_hash !== "undefined"
      // ) {
      //   myCalendarService.insertActivity(
      //     this.campaign_hash,
      //     this.business_contact_hash,
      //     true,
      //     "Next Month: " + this.theyear + "/" + currentmonth
      //   );
      // }
    },
    getAvailabilityByMonth(month,theyear,account_id){
   
      //console.log("GET MONTH "+month)
      this.loading = true
      this.calendar.currentmonth = month
      this.calendar.account_id = account_id
      this.calendar.currentyear = theyear
      myCalendarService.getAvailabilityByMonth(month,theyear,this.account_id,this.timezone).then((res) => {
        if(res){
          const { availability } = res
          this.loadDaysAvailable(availability)
          this.loading = false
          this.loadingfirst = false
        }else{
        }
      })
    },
    loadDaysAvailable(data){
      if(data){
        const daysAvailableCurrentMonth = data.filter( el => el > 0)
        

        if(daysAvailableCurrentMonth.length > 0){
          
          let datesAvailableToMonthSelectedTemp = []
          daysAvailableCurrentMonth.forEach( (el, index) => {
            
            const value = `${this.theyear}-${this.currentmonth}-${index + 1}`

            const formattedDate = moment(value, 'YYYY-M-D').format('YYYY/MM/DD');
            const dayName = moment(formattedDate, 'YYYY-MM-DD').format('dddd');

            datesAvailableToMonthSelectedTemp.push(
              {
                id: index + 1,
                day: formattedDate,
                available: (el == 2) ? true : false,
                dayName: dayName
              }
            )
            
          })

          this.datesAvailableToMonthSelected = datesAvailableToMonthSelectedTemp.filter( el => el.available) // .map( e => (e.day))
          this.keyDateAvailable++
        }         
      }
      
    },
    selectTimeZone(event) {
      this.dateAvailableSelected = null
      this.hoursAvailableSelected = null
      const selectedValue = event && event.target ? event.target.value : event;
      if (event && event.target) {
        this.timezoneSource = "manual";
      }
      this.timezone = selectedValue;
      this.timezones.forEach((item, key) => {
        if (item.id == this.timezone) {
          this.calendar.timezonelabel = item.label;
          this.calendar.defaultTimezone = item.id;
          this.calendar.timezone = item.id;
          return false;
        }
      });
      this.nextMonth(this.currentmonth, false);
    },
    selectTimeZoneLabel(label) {
      this.calendar.timezonelabel = label;
      this.timezones.forEach((item, key) => {
        if (item.label.indexOf(this.calendar.timezonelabel) !== -1) {
          this.calendar.timezonelabel = item.label;
          this.calendar.defaultTimezone = item.id;
          this.timezone = item.id;
          return;
        }
      });
      this.nextMonth(this.currentmonth, false);
      return;
    },
    close(event) {
      this.$emit("close");
    },
    ...mapActions("opportunities", {
      reloadOpportunity: "reloadOpportunity",
    }),
    isValidEmailForm() {
      this.$refs.emailForm.validate();
      this.$refs.editorMessageV.validate();
      return (
        this.$refs.emailForm.errors.length == 0 &&
        this.$refs.editorMessageV.errors.length == 0
      );
    },
    response_email() {
      this.reply_email.response_id = this.selected.response_id;
      this.reply_email.to = this.selected.response_from;
      this.reply_email.cc = this.selected.response_cc;
      this.reply_email.subject = "RE: " + this.selected.response_subject;
    },
    generate_answer() {
      this.startLoadingSendEmail = true
      openaiService.getAnswer(this.selected.id).then((result) => {
          this.editorData = result.data[0].replaceAll('\n', '<br>');
          this.startLoadingSendEmail = false;
      }).catch((errr)=>{
        this.startLoadingSendEmail = false;
      });
    },
    show_prompts() {
      this.startLoadingSendEmail = true
      openaiService.getPrompts(this.selected.id).then((result) => {
          this.systemPrompt = result.data[0].systemPrompt;
          this.userPrompt = result.data[0].userPrompt;
          this.startLoadingSendEmail = false;
          this.showPrompts = true
      });
    },
    hide_prompts() {
      this.startLoadingSendEmail = true
      this.showPrompts = false
      this.startLoadingSendEmail = false
    },
    cleanFields() {
      this.reply_email.to = "";
      this.reply_email.message = "";
      this.reply_email.subject = "";
      this.reply_email.cc = "";
      this.editorData = "";
      systemPrompt: "";
      userPrompt: "";
    },
    getTemplateList() {
      const linkId = this.selected && this.selected.link_id;
      if (!linkId) {
        return;
      }
      if (this.$store.getters["emails/hasTemplatesForLink"](linkId)) {
        return;
      }
      this.loadingTemplates = true;
      this.$store
        .dispatch("emails/ensureEmailTemplates", { linkId })
        .finally(() => {
          this.loadingTemplates = false;
        });
    },
    addTemplete(id) {
      this.getTemplate(id);
    },
    getTemplate(id) {
      this.loadingCurrent = true;
      emailsService
        .getTemplate(id)
        .then((result) => {
          this.editorData = result.message;
        })
        .catch((err) => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.loadingCurrent = false;
        });
    },
    sendEmail() {
      if (this.isValidEmailForm()) {
        this.emailSent = true;
        emailsService
          .replyEmail(this.reply_email)
          .then((result) => {
            this.emailSent = false;
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              showConfirmButton: false,
              timer: 1500,
            });
            this.close();
          })
          .catch((error) => {
            this.emailSent = false;
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text:
                error && error.error
                  ? error.error
                  : this.$t("lang.label.error"),
              showConfirmButton: true,
            });
          });
      }
    },
  },
};
</script>
<style>
.field-inline {
  display: flex;
  flex-wrap: wrap;
}
.field-inline .field-wrap {
  flex: 1 0 auto;
}
.field-inline > label {
  margin: 0;
  background: grey;
  background-color: #e9ecef;
  padding-right: 10px;
  padding-top: 5px;
  border-radius: 3px 0px 0px 3px;
}
.field-inline label > :first-child {
  padding: 0 10px;
}
.field-inline .errors {
  flex-basis: 100%;
}
.buttonSeparator {
  margin-right: 10px;
}
</style>
